const Big = require('big.js')
// 百分比计算
export function calculate(x,y) {
    x = Big(x);
    y = Big(y);
    let z = x.div(y)
    let data1 = (z*100).toFixed(2)+"%"
    return data1
  }